module.exports = __webpack_public_path__ + "img/hourglass.004024d0.gif";